import wrapPageElementWithTransition from './src/components/wrap-page-element'

export const wrapPageElement = wrapPageElementWithTransition
